module.exports = __webpack_public_path__ + "img/cc.c1ce977e.png";